import { c as _c } from "react/compiler-runtime";
import { BrowserRouter } from "react-router";
import { AppRoutes } from "./router";
import "./index.css";
export function App() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <BrowserRouter><AppRoutes /></BrowserRouter>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default App;